import { Component, OnInit, EventEmitter, Output,ViewChild,ElementRef,ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService,CommonService } from 'src/app/services';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxUiLoaderService } from 'ngx-ui-loader';
declare var $:any;
declare var JQuery: any;

@Component({
  selector: 'app-viewprofile',
  templateUrl: './viewprofile.component.html',
  styleUrls: ['./viewprofile.component.scss'],
  providers:[NgxUiLoaderService]
})
export class ViewprofileComponent implements OnInit {
  UserDataShow1:any;
  public imagePath;
  imgURL: any;
  public message: string;

  public edit:boolean=true;

  bodydata:any={}; loadData:any; createForm: FormGroup;
  UserDataShow:any;UserData:any;UserID:any;
  selectedFile: File=null;
  allCountry:any;
  allstate:any;
  allcity:any;
  imagepath:any;
  userimage:any;
  hidediv:boolean=false;
  submitted:boolean=false;
  constructor(private ngxLoader: NgxUiLoaderService,private formBuilder: FormBuilder,private sanitizer: DomSanitizer,
    public sharedService: SharedserviceService,public commonService:CommonService,private toastr: ToastrManager) { 
      if(this.commonService.getUser()){
        this.UserData = JSON.parse(this.commonService.getUser());
        this.UserID = this.UserData.id;
        sharedService.auth_token=this.UserData.login_token
      }
      
    }

  ngOnInit() {
    if(this.UserData.role_id == 2 || this.UserData.role_id == 4){
      this.createForm = this.formBuilder.group({
        company_name: '',
        website: '',
        address: ['', Validators.required],
        address_2: ['', Validators.required],
        country_id: ['93', Validators.required],
        city: ['', Validators.required],
        // profile_city: ['', Validators.required],
        state_id: [''],
        zipcode: ['', Validators.required],
        email: ['', Validators.required],
        image: '',
        mobile: ['', Validators.required],
        name: ['', Validators.required],
        pan_no: '',
        ref_id: ['', Validators.required],
        gst_no: ''
      });
    }else{
      this.createForm = this.formBuilder.group({
        company_name:'',
        website: '',
        address: ['', Validators.required],
        address_2: '',
        country_id: ['93', Validators.required],
        city: ['', Validators.required],
        // profile_city: ['', Validators.required],
        state_id: [''],
        zipcode: ['', Validators.required],
        email: ['', Validators.required],
        image: '',
        mobile: ['', Validators.required],
        name: ['', Validators.required],
        pan_no: '',
        ref_id: ['', Validators.required],
        gst_no: ''
      });
    }
        
    this.loadList();
    this.loadstate(93)
    this.bodydata['page'] = '1';
  }
  get f() { return this.createForm.controls; }
  allowurl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  preview(files) {
    //
//console.log("sadawwa",files)
   if (files.length === 0)
     return;
 
   var mimeType = files[0].type;
   if (mimeType.match(/image\/*/) == null) {
     this.message = "Only images are supported.";
     return;
   }
 
   var reader = new FileReader();
   this.imagePath = files;
   reader.readAsDataURL(files[0]); 
   reader.onload = (_event) => { 
     this.userimage = reader.result; 
     this.message='';
   }
 }
 changetoEdit(){
  if(this.edit == true){
    this.edit=false;
  }else{
    this.edit=true;
  }
 }

 loadList() {
  this.hidediv = true;
  this.ngxLoader.start();
  var request = {
  }
  this.sharedService.post('v1/users/view_profile', request).subscribe(res => {

    if (res['replyCode'] == "success") {
      this.UserDataShow = res.data;
      if(this.UserDataShow){
        this.imagepath = res.imageurl;
        this.userimage = this.imagepath + "/" + this.UserDataShow.user_image;
        this.setDefaultDataInProfile(this.UserDataShow);
      }

    } else {
      this.ngxLoader.stop();
    }
  }, err => {
    this.ngxLoader.stop();
    this.toastr.errorToastr(err['error']['message'], 'Error');
  });
}

  loadcountry(){  
    this.sharedService.getRequest1('v1/all_country').subscribe(res =>{
        if(res['replyCode'] == "success"){
          this.allCountry = res.data;          
        }else{
          // alert()
        }
    },err=>{
      this.toastr.errorToastr(err['error']['message'], 'Error');
    });
  }
  loadstate(id){
    id=93
    this.sharedService.get(`v1/state_list/${id}`).subscribe(res =>{
      if(res['replyCode'] == "success"){
        this.allstate = res.data;
      }else{
        // alert()
      }
  },err=>{
    this.toastr.errorToastr(err['error']['message'], 'Error');
  });
  }
  loadcity(id){
    this.sharedService.get1(`v1/city_list/${id}`).subscribe(res =>{
      if(res['replyCode'] == "success"){
        this.allcity = res.data;
      }else{
        // alert()
      }
  },err=>{
    this.toastr.errorToastr(err['error']['message'], 'Error');
  });
  }
  
  setDefaultDataInProfile(event) {
    this.createForm.patchValue({
      company_name: event.company_name == null ? '' : event.company_name,
      website: event.website == null ? '' : event.website,
      address: event.user_address == null ? '' : event.user_address,
      address_2: event.user_address_2 == null ? '' : event.user_address_2,
      country_id: event.country_id == null ? 93 : event.country_id,
      city: event.city == null ? '' : event.city,
     // profile_city: event.profile_city == null ? '' : event.profile_city,
      state_id: event.state_id == null ? '' : event.state_id,
      zipcode: event.zipcode == null ? '' : event.zipcode,
      email: event.user_email == null ? '' : event.user_email,
      image: event.user_image == null ? '' : event.user_image,
      mobile: event.user_mobile == null ? '' : event.user_mobile,
      name: event.user_name == null ? '' : event.user_name,
      pan_no: event.pan_no == null ? '' : event.pan_no,
      ref_id: event.user_reference_id == null ? '' : event.user_reference_id,
      gst_no: event.gst_no == null ? '' : event.gst_no
    });
    this.hidediv=false;
    this.ngxLoader.stop();
  }
  onFileChanged1(event) {
    this.selectedFile = event.target.files[0];
  }
  isEmpty(val){
    return (val === undefined || val == null ) ? true : false;
  }
  onUpdateProfile(){
    var self= this;
    this.submitted = true;
    if(this.createForm.valid){
      this.ngxLoader.start();
      const uploadData = new FormData();
      if(self.selectedFile == null){
        uploadData.append('image','');
      }else{
        uploadData.append('image', self.selectedFile, self.selectedFile.name);
      }
      uploadData.append('id', self.UserID);
      uploadData.append('address', self.createForm.value.address);
      uploadData.append('address_2', self.createForm.value.address_2);
      uploadData.append('city', self.createForm.value.city);
      uploadData.append('company_name', self.createForm.value.company_name);
      uploadData.append('website', self.createForm.value.website);
      uploadData.append('country_id', self.createForm.value.country_id);
      uploadData.append('email', self.createForm.value.email);
      uploadData.append('gst_no', self.createForm.value.gst_no);
      uploadData.append('mobile', self.createForm.value.mobile);
      uploadData.append('name', self.createForm.value.name);
      uploadData.append('pan_no', self.createForm.value.pan_no);
      uploadData.append('state_id', self.createForm.value.state_id);
      uploadData.append('zipcode', self.createForm.value.zipcode);
      self.sharedService.postRequest('v1/users/edit_profile',uploadData).subscribe((res: any) => {
        if (res.replyCode == 'success') {
          this.changetoEdit()
          // localStorage.setItem("imgpathAgency", JSON.stringify(this.UserDataShow1.imageurl));
          self.submitted = false;
          self.loadList();
          // this.commonService.userinfo();
          this.ngxLoader.stop();
          self.toastr.successToastr(res.replyMsg, 'Success',{timeOut:200});
          
        } else {
          this.ngxLoader.stop();
          self.toastr.errorToastr(res.error.replyMsg,'Error Message',{ timeOut: 200});
        }
      },error => {
        this.ngxLoader.stop();
          self.toastr.errorToastr(error.error.replyMsg,'Error Message',{ timeOut: 200});
      });
    }else{
      self.toastr.errorToastr(" Please Fill Form Completely",'Error Message',{ timeOut: 200});
    }

    
  }


  numberOnly(event): boolean {
   const charCode = (event.which) ? event.which : event.keyCode;
   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
   }
   return true;
   }
   charactoronly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    // allow letters and whitespaces only.
    if(!(charCode >= 65 && charCode <= 122) && (charCode != 32 && charCode != 0)) { 
        return false; 
    }
    return true;
  } 
  hideloader() { 
    $('#loader').hide(); 
  }
  showloader() { 
    $('#loader').show(); 
  }
}
